import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/[[...slug]]/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/organisms/Navigation/Navigation.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/utils/useIsInView/useIsInView.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/utils/useIsomorphicLayoutEffect.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/utils/useScrollProgress/useScrollProgress.ts");
